module.exports = __webpack_public_path__ + "img/Delivery.dc34a187.svg";